import { copyToClipboard } from "./copyToClipboard";

type Inputs = {
  buttonElement: HTMLElement | null;
  feedbackElement: HTMLElement | null;
};

export function initCopyLoginLink({ buttonElement, feedbackElement }: Inputs): void {
  if (!buttonElement) return;

  buttonElement.addEventListener("click", () => {
    const url = buttonElement.dataset.loginLinkUrl;
    if (!url) return;

    copyToClipboard(url).then(() => {
      showFeedback(feedbackElement);
    });
  });
}

export function showFeedback(feedbackElement: HTMLElement | null): void {
  if (!feedbackElement) return;

  feedbackElement.classList.remove("hidden");
}
